export default __webpack_public_path__ + "static/media/24.cef68082.jpg";